import React, { Component } from "react";
import Helmet from "react-helmet";
import Header from "../components/Header/Header";
import SocialLinks from "../components/SocialLinks/SocialLinks";
import SEO from "../components/SEO/SEO";
import Conseil from "../components/Page/Conseil";
import HeaderPage from "../components/Header/HeaderPage";
import Menu from "../components/Menu/Menu";
import Footer from "../components/Footer/Footer";
import picture from "./img/innovation-application-web.jpg";
import config from "../../data/SiteConfig";
import Contact from "../components/Contact/Contact";
import "./page.scss";

export default class ConseilApp extends Component {
  render() {
    // SEO PURPOSES
    const { slug } = this.props.pathContext;


    const postNode = {
        "frontmatter": {
            "title": "Conseil, Audit & accompagnement",
            "description":  "Notre Agence Web vous propose de vous accompagner dans tous vos projets Web et Mobile à l'aide de services complémentaires, réalisés par des experts !",
            "cover": picture
        }
    };

    let title = "Conseil, Audit & accompagnement";
    let description = "Notre expertise à votre service";
    let goto = "En découvrir plus";

    return (
      <div className="webapp-container page-details">
          <Header/>
          <Menu />
          <Helmet 
          title={`Conseil, Audit & accompagnement | ${config.siteTitle}`}
          description = {`Notre Agence Web vous propose de vous accompagner dans tous vos projets Web et Mobile à l'aide de services complémentaires, réalisés par des experts !`}
          />
          <SEO postPath={slug} postNode={postNode} postSEO />
          <HeaderPage title={title} description={description} picture={picture} />
          <Conseil />
          <Contact />
          <SocialLinks postPath={slug} postNode={postNode} />
          <Footer />
      </div>
    );
  }
}
;


// WEBPACK FOOTER //
// ./src/pages/conseil.jsx